<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('Headers.sign')"></header-big>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="12">
        <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <header-medium :text="$t('OdisCallback.Title')" />
              </v-col>
            </v-row>
            <v-row v-if="!checked">
              <v-container class="ma-0 pa-0 mw-100">
                <p v-text="$t('RedirectQES.Message_a')" class="text-center mb-0" />
              </v-container>
              <v-container class="ma-0 pa-0 mw-100">
                <p v-text="$t('RedirectQES.Message_b')" class="text-center mb-0" />
              </v-container>
              <v-col class="
                  button__full
                  d-flex
                  justify-xs-center
                  justify-sm-center
                  justify-md-center
                  justify-lg-center
                ">
                <div class="half-circle-spinner ma-0 pa-0 mw-100">
                  <div class="circle circle-1 ma-0 pa-0 mw-100"></div>
                  <div class="circle circle-2 ma-0 pa-0 mw-100"></div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="checked">
              <v-container class="ma-0 pa-0 mw-100" v-if="success">
                <v-row>
                  <v-col cols="12">
                    <strong>
                      <p v-text="$t('RedirectQES.checked')" class="text-center mb-5" />
                    </strong>
                  </v-col>
                </v-row>

                <v-row v-if="!certificateExists">
                  <v-col cols="12">
                    <v-alert :color="mainColor" text type="info">
                      {{ $t("info_certificate_password") }}
                    </v-alert>
                  </v-col>
                </v-row>

                <v-form ref="createCertificatePassword">
                  <v-row v-if="!certificateExists">
                    <v-col cols="6">
                      <v-text-field v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'" :label="$t('password')" dense
                        @click:append="showPassword = !showPassword" :rules="rules.password"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field :rules="rules.passwordConfirmationRules" v-model="confirmPassword" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                        " :type="showConfirmPassword ? 'text' : 'password'" name="input-10-1"
                        :label="$t('repeat_password')" @click:append="
                          showConfirmPassword = !showConfirmPassword
                          " dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!certificateExists">
                    <v-col cols="6">
                      <vue-tel-input-vuetify v-model="phone" @input="checkPhone" defaultCountry="DE"
                        :placeholder="$t('phone')" :label="$t('phone')" :error-messages="errorsPhone" mode="international"
                        data-cy="contactPhone" />
                    </v-col>
                  </v-row>
                </v-form>

                <div class="text-center pt-5">
                  {{ $t("RedirectQES.revoke_hint") }}
                  <a target="_blank" href="https://signing.sign8.eu/revoke" @click.stop>
                    {{ $t("RedirectQES.revoke_url") }}
                  </a>
                  {{ $t("RedirectQES.revoke_hint_2") }}
                </div>
                <div class="text-center mb-0">
                  {{ $t("RedirectQES.more_info") }}
                  <a target="_blank" href="https://sign8.eu/trust" @click.stop>
                    {{ $t("RedirectQES.trust_url") }}
                  </a>
                </div>
              </v-container>
              <v-container class="ma-0 pa-0 mw-100" v-if="!success">
                <v-alert v-if="ausweisAppClosed" type="warning" text class="mb-4">
                  {{ $t('OdisCallback.ausweisapp_closed_hint') }}
                </v-alert>
                <p v-text="$t('RedirectQES.wrong')" class="text-center mb-0" />
              </v-container>
              <v-col cols="12" sm="12" class="text-right">
                <custom-button v-if="!success" :text="$t('Navigation.redirect_login')" @click="redirect"></custom-button>
              </v-col>
              <v-col cols="12" sm="12" class="text-right">
                <custom-button :disabled="disabled" v-if="success" :text="buttonText" @click="sign"></custom-button>
              </v-col>
            </v-row>
          </v-card-text>
          <custom-overlay></custom-overlay>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import i18n from "@/i18n";
import HeaderBig from "../../components/ui/text/HeaderBig.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import CustomButton from "../../components/ui/input/CustomButton.vue";
import { log } from "@/helpers/logger";
import BaseTimer from "../../components/ui/other/BaseTimer.vue";
import cookie from "vue-cookies";
import CustomOverlay from "../../components/ui/other/Overlay.vue";

export default {
  name: "odis-callback",
  title: i18n.t("Headers.sign"),
  components: {
    HeaderBig,
    HeaderMedium,
    CustomButton,
    BaseTimer,
    CustomOverlay,
  },
  data() {
    return {
      mainColor: this.$vuetify.theme.themes.light.primary,
      phone: "",
      errorsPhone: "",
      code: "",
      workflow_id: null,
      signer_id: null,
      checked: false,
      success: false,
      message: "",
      buttonText: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      ident_signer: { first_name: '', last_name: '' },
      rules: {
        password: [
          (v) => !!v || this.$t("required"),
          (v) => (v && v.length >= 8) || this.$t("password_min_length"),
          (v) => /(?=.*[A-Z])/.test(v) || this.$t("password_upper_case"),
          (v) => /(?=.*[a-z])/.test(v) || this.$t("password_lower_case"),
          (v) => /(?=.*\d)/.test(v) || this.$t("password_number"),
          (v) => /([@$!%*?&])/.test(v) || this.$t("password_special_chars"),
        ],
        passwordConfirmationRules: [
          (v) => !!v || this.$t("required"),
          (v) => v == this.password || this.$t("password_identical"),
        ],
      },
    };
  },
  created: async function () {
    this.workflow_id = cookie.get("workflow_id");
    this.signer_id = cookie.get("signer_id");

    this.color = this.$vuetify.theme.themes.light.primary;

    this.type = cookie.get("signer_type");
    this.buttonText =
      this.type.split("_")[1] === "signature"
        ? i18n.t("Navigation.sign_now")
        : i18n.t("Navigation.seal_now");

    if (this.$route.query.error) {
      log(
        "OdisCallback.created - redirect error" +
        (this.$route.query.error_description || this.$route.query.error_reason || this.$route.query.error) +
        " signer: " +
        this.signer_id,
        "error"
      );

      this.checked = true;
      this.success = false;
    }

    if (this.$route.query.code) {
      this.code = this.$route.query.code;

      var data = {
        workflow_id: cookie.get("workflow_id"),
        signer_id: cookie.get("signer_id"),
        code: this.code,
      };

      await this.$store
        .dispatch("data/odisCallback", data)
        .then((res) => {
          log(
            "OdisCallback.created() - create case for: " +
            this.signer_id,
            "info"
          );
          this.checked = true;
          if (res.success) {
            this.success = true;
            this.ident_signer.first_name = res.first_name;
            this.ident_signer.last_name = res.last_name;
            this.ident_signer.country = res.country;
          } else {
            this.success = false;
          }
        })
        .catch((err) => {
          log(
            "OdisCallback.created() - " + err + " signer: " + this.signer_id,
            "error"
          );
          this.success = false;
        });
    }
  },
  computed: {
    disabled() {
      return this.$store.state.loading;
    },
    certificateExists() {
      var castToBool = (cookie.get("certificate_exists") === 'true')
      return castToBool
    },
    ausweisAppClosed() {
      const err = this.$route.query.error;
      const desc = (this.$route.query.error_description || "").toLowerCase();
      return err === "access_denied" || desc.includes("ausweisapp");
    }
  },
  methods: {
    checkPhone(number, phone) {
      if (phone.isValid || number == "") {
        this.errorsPhone = "";
        this.user.phone = phone.number.e164;
        this.check = true;
        return true;
      } else {
        this.errorsPhone = i18n.t("FormValidation.phone");
        this.check = false;
        return false;
      }
    },
    redirect() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push("/login/" + this.workflow_id + "/" + this.signer_id);
    },
    async sign() {
      if (!cookie.get("auth-token")) {
        await this.$router.push(
          "/login/" + this.workflow_id + "/" + this.signer_id
        );
      }
      await this.$store
        .dispatch("data/signNowQES", {
          ident_signer: this.ident_signer,
          files: this.currentFiles,
          auth_token: cookie.get("auth-token"),
          otp: this.otp,
          password: this.password,
          phone: this.phone,
          gateway: "odis"
        })
        .then(() => {
          log("OdisCallback.sign() - sign now workflow " + this.workflow_id + " by signer " + this.signer_id, "info");
          this.$router.push("/summary/finished");
        })
        .catch((err) => {
          this.otp = "";
          log("OdisCallback.sign() - " + err, "error");
        });
    },
  },
};
</script>

<style>
.half-circle-spinner,
.half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;
}

.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(60px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: #1e6569;
  animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: #1e6569;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
